import 'bootstrap/dist/css/bootstrap.css';
import '@veneer/core/dist/css/veneer.css';
import { ThemeProvider, ToastProvider } from '@veneer/core';
import './assets/scss/custom.scss';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import '@veneer/core/dist/css/veneer.css';
import './assets/scss/global.scss';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Suspense fallback={null}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider mode="light" shape="round" density="high">
          <ToastProvider>
            <App />
          </ToastProvider>
        </ThemeProvider>
      </I18nextProvider>
    </Suspense>
  </BrowserRouter>,
  rootElement
);

//registerServiceWorker();
